// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamburger-outer {
  display: flex;
  position: relative;
  min-width: 25px;
}

.hamburger {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 5px;
  transition: transform 0.3s ease-in-out;
  max-width: 35px;
  min-width: 40px;
}

.line {
  width: 2px;
  height: 3px;
  background-color: #333;
  margin: 1px;
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
}

.hamburger:hover .line:nth-child(1) {
  width: 20px;
}

.hamburger:hover .line:nth-child(2) {
  width: 20px;
}

.hamburger:hover .line:nth-child(3) {
  width: 20px;
}


.hamburger.open {
  background-color: #e2e2e2;
  border-radius: 5px;
}

.hamburger.open .line:nth-child(1) {
  transform: translateX(-6px) translateY(5px) rotate(-50deg);
  width: 20px;
}

.hamburger.open .line:nth-child(2) {
  opacity: 0;
}

.hamburger.open .line:nth-child(3) {
  transform: translateX(6px) translateY(-5px) rotate(50deg);
  width: 20px;
}

.dropdown-content {
  position: absolute;
  width: 100%;
  transition: top 0.3s ease-in-out, opacity 0.3s ease-in-out;
  z-index: -100;
  opacity: 0;
}

.dropdown-content.show {
  max-width: none;
  max-height: none;
  z-index: 1000;
  opacity: 1;
}

/* Additional styles for dynamic positioning */
.dropdown-content.show {
  top: 100%; /* Set initial position to 100% */
  left: 2vw;
}

/* Adjust position based on available space */
.dropdown-content.show.top {
  top: -100%; /* Change to -100% for cases where there's more space at the top */
}
`, "",{"version":3,"sources":["webpack://./src/components/hamburger/hamburger.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,8DAA8D;AAChE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yDAAyD;EACzD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0DAA0D;EAC1D,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,SAAS,EAAE,iCAAiC;EAC5C,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,UAAU,EAAE,kEAAkE;AAChF","sourcesContent":[".hamburger-outer {\n  display: flex;\n  position: relative;\n  min-width: 25px;\n}\n\n.hamburger {\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 5px;\n  transition: transform 0.3s ease-in-out;\n  max-width: 35px;\n  min-width: 40px;\n}\n\n.line {\n  width: 2px;\n  height: 3px;\n  background-color: #333;\n  margin: 1px;\n  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;\n}\n\n.hamburger:hover .line:nth-child(1) {\n  width: 20px;\n}\n\n.hamburger:hover .line:nth-child(2) {\n  width: 20px;\n}\n\n.hamburger:hover .line:nth-child(3) {\n  width: 20px;\n}\n\n\n.hamburger.open {\n  background-color: #e2e2e2;\n  border-radius: 5px;\n}\n\n.hamburger.open .line:nth-child(1) {\n  transform: translateX(-6px) translateY(5px) rotate(-50deg);\n  width: 20px;\n}\n\n.hamburger.open .line:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.open .line:nth-child(3) {\n  transform: translateX(6px) translateY(-5px) rotate(50deg);\n  width: 20px;\n}\n\n.dropdown-content {\n  position: absolute;\n  width: 100%;\n  transition: top 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  z-index: -100;\n  opacity: 0;\n}\n\n.dropdown-content.show {\n  max-width: none;\n  max-height: none;\n  z-index: 1000;\n  opacity: 1;\n}\n\n/* Additional styles for dynamic positioning */\n.dropdown-content.show {\n  top: 100%; /* Set initial position to 100% */\n  left: 2vw;\n}\n\n/* Adjust position based on available space */\n.dropdown-content.show.top {\n  top: -100%; /* Change to -100% for cases where there's more space at the top */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
